import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { noop } from '@/util';
import ExportFile from '@/views/components/exportFile';

@DialogFactory
@Component({
  mixins: [style],
	components: {
		ExportFile,
	}
})
export default class OperateHistory extends IPSDialog {
  sgId: number;

  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '操作履历';

  width = '800px';

  cancelText = '关闭';

  tableSelected = [];

  mounted() {
    this.getDataList();
  }

  getDataList() {}

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getDataList();
  }

  onPageChange(val) {
    this.page = val;
    this.getDataList();
  }

  handleSearch() {
    this.page = 1;
    this.getDataList();
  }

  onSelected(val) {
    this.tableSelected = val;
  }

  onConfirm() {
    this.$emit('result', this.tableSelected);
    this.$emit('hidden');
  }

  onSelect(row) {
    const id = row.qiKanId;
    const name = row.qiKanContent;
    this.$emit('result', { id, name });
    this.$emit('hidden');
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper wid-390">
            <el-input v-model={this.keyword} placeholder="输入商品货号、操作人进行模糊检索"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table data={this.dataList} on-selection-change={this.onSelected.bind(this)} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="" width="40" />
          <el-table-column prop="qiKanId" label="商品货号" width="140px" show-overflow-tooltip></el-table-column>

          <el-table-column prop="qiKanContent" label="商品名称" show-overflow-tooltip width="180px"></el-table-column>
          <el-table-column prop="qiKanContent" label="动作" show-overflow-tooltip width="140px"></el-table-column>
          <el-table-column prop="qiKanContent" label="操作人" show-overflow-tooltip width="140px"></el-table-column>
          <el-table-column prop="date" align="center" label="操作时间" width="160px" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="bottomWrapper border-bottom-white">
          <ExportFile export-text="导出Excel" params="" is-button={false} service-url=""></ExportFile>
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
